import {Component, Input} from '@angular/core';
import {PodState} from '../shared/pod-validation.model';

@Component({
  selector: 'app-pods-validation-state',
  templateUrl: './pods-validation-state.component.html',
  styleUrls: ['./pods-validation-state.component.scss']
})
export class PodsValidationStateComponent {

  @Input()
  public state: PodState;

  public POD_STATE = PodState;

}
